export default __webpack_public_path__ + "static/james-brown-ascii-3-7ea321434320b418771cab0cdf5ed2a7.png";